import {mergeStyleSets, Theme} from "@fluentui/react";

export const createStyles = (theme:Theme) => mergeStyleSets({
  filterManager: {
    backgroundColor: theme.semanticColors.disabledBackground,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  conditionList: {
    backgroundColor: theme.semanticColors.inputBackground,
  },
  bottomPanel: {
    display: 'flex',
    padding: '0 8px',
    justifyContent: 'center',
    '& button': {
      width: '100%',
      maxWidth: '350px',
    }
  }
})
